<template>
  <div id="app">
    <div v-if="isLoading">
      <section class="section is-medium">
        <img src="./assets/glass_blowing.gif" alt="loading" />
        <h1 class="title is-1 has-text-white">page is loading...</h1>
      </section>
    </div>

    <div v-show="!isLoading">
      <router-view />
      <!-- <div class="container">
        <div class="box">
          <img alt="logo" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/hvclogo.png?alt=media" width="20%">
          <p class="title is-2 has-text-white">Hidden Village Creations website is under maintenance. We will be back soon!</p>
          <p class="title is-2 has-text-white">During the downtime, please visit our social media to get the latest info.</p>

          <p>

          </p>
        </div>
      </div> -->

      
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  },
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    window.addEventListener('load', () => {
      this.isLoading = false
    })
  },
  
}
</script>

<style>
body {
  overflow: hidden;
}

body::-webkit-scrollbar {
  display: none;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.icon-margin {
  margin: 10px;
}

.icon-margin:hover {
  color: #0ABAB5;
}

</style>
